<template>
  <v-sheet>
    <ChapterConnection
      v-for="connection in connections"
      :key="connection.id"
      :connection="connection"
      :chapters="chapters"
      :chapterId="chapter.id"
      :storyId="chapter.story.id"
    />
    <AddConnection :chapter="chapter" />
  </v-sheet>
</template>
<script>
import AddConnection from './AddConnection'
import ChapterConnection from "./ChapterConnection";
export default {
  components: {
    ChapterConnection,
    AddConnection
  },
  props: {
    chapters: Array,
    chapter: Object,
  },
  computed: {
    connections() {
      return this.chapter.chapterConnectors
    }
  }
};
</script>